<template>
  <div class="card">
    <div class="op--message">
      {{ $t('rsvpTrack.bestExp', {brandName: brandName}) }}
    </div>
    <div class="row margin-t-xs">
      <div class="small-6 column padding-r-xs">
        <a class="op-btn btn-block" :href="appLinks.ios" target="_blank">
          <i class="fab fa-apple"></i>
          <span>{{ $t('rsvpTrack.appStore') }}</span>
        </a>
      </div>
      <div class="small-6 column padding-l-xs">
        <a class="op-btn btn-block" :href="appLinks.android" target="_blank">
          <i class="fab fa-google-play"></i>
          <span>{{ $t('rsvpTrack.playStore') }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'consurmer-app-links',
  computed: {
    brandCode () { return this.$store.state.brandCode },
    brandName () {
      let self = this
      if (self.brandCode === 'op') {
        return 'Opoli'
      }
      if (self.brandCode === 'gs') {
        return 'GoSedan'
      }
      if (self.brandCode === 'pts') {
        return 'Prime Time Shuttle'
      }
      if (self.brandCode === 's2l') {
        return 'Shuttle2Anywhere'
      }
      // Should not happen
      return null
    },
    appLinks () {
      let self = this
      if (self.brandCode === 'op') {
        return {
          ios: 'https://itunes.apple.com/us/app/opoli/id872133514?mt=8',
          android: 'https://play.google.com/store/apps/details?id=com.opoli.consumer&hl=en'
        }
      }
      if (self.brandCode === 'gs') {
        return {
          ios: 'https://itunes.apple.com/us/app/gosedan/id1138372066?mt=8',
          android: 'https://play.google.com/store/apps/details?id=com.gosedan.consumer&hl=en'
        }
      }
      if (self.brandCode === 'pts') {
        return {
          ios: 'https://itunes.apple.com/us/app/prime-time-shuttle/id1140549792?mt=8',
          android: 'https://play.google.com/store/apps/details?id=com.primetime.consumer&hl=en'
        }
      }
      if (self.brandCode === 's2l') {
        return {
          ios: 'https://itunes.apple.com/us/app/shuttle2anywhere/id1138372070?mt=8',
          android: 'https://play.google.com/store/apps/details?id=com.shuttle2lax.consumer&hl=en'
        }
      }
      // Should not happen
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
.op--message{
  margin-bottom: 10px;
}
.row{
  margin: 0!important;
}
</style>



// WEBPACK FOOTER //
// ConsumerAppLinks.vue?9dc8288c